module.exports = __webpack_public_path__ + "static/media/tti_save_time@2x.14523136.png";